import { Button, Card, Dialog, Flex } from '@radix-ui/themes';
import { EB } from 'components/layout/error-boundary';
import { RX } from 'enums/radix';
import { DialogDef } from 'interfaces/dialog';

const Content = (props: DialogDef) => {
  return (
    <Dialog.Root
      onOpenChange={(v) => {
        if (!v) {
          props.onClose();
        }
      }}
      open
    >
      {props.trigger && <Dialog.Trigger>{props.trigger}</Dialog.Trigger>}

      <Dialog.Content size="2">
        <Dialog.Title>{props.title}</Dialog.Title>

        {props.description && (
          <Dialog.Description>
            <Card mb="4">{props.description}</Card>
          </Dialog.Description>
        )}

        {props.children}

        <Flex mt="4" gap="2" justify="end">
          <Dialog.Close>
            <Button variant="soft" color={RX.CLR.NEUTRAL}>
              Cancel
            </Button>
          </Dialog.Close>

          {props.extraActions}
        </Flex>
      </Dialog.Content>
    </Dialog.Root>
  );
};

export const CommonDialog = (props: DialogDef) => {
  return (
    <EB>
      <Content {...props} />
    </EB>
  );
};
